import React from 'react';
import PropTypes from 'prop-types';

/**
 * Reusable button component
 */
const Button = ({ 
  children, 
  variant = 'default',
  size = 'md',
  className = '',
  rightIcon,
  leftIcon,
  ...props 
}) => {
  const baseClasses = "inline-flex items-center justify-center font-medium transition-all focus:outline-none focus:ring-2 focus:ring-offset-2";
  
  const variantClasses = {
    default: "text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 focus:ring-purple-500",
    primary: "text-white bg-purple-600 hover:bg-purple-700 focus:ring-purple-500",
    secondary: "text-gray-900 bg-gray-100 hover:bg-gray-200 focus:ring-gray-500",
    success: "text-white bg-emerald-600 hover:bg-emerald-700 focus:ring-emerald-500"
  };

  const sizeClasses = {
    sm: "px-3 py-1.5 text-sm rounded-md gap-1",
    md: "px-4 py-2 text-sm rounded-lg gap-1.5",
    lg: "px-6 py-3 text-base rounded-lg gap-2"
  };

  return (
    <button
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
      {...props}
    >
      {leftIcon && <span className="inline-block">{leftIcon}</span>}
      {children}
      {rightIcon && <span className="inline-block">{rightIcon}</span>}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['default', 'primary', 'secondary', 'success']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string,
  rightIcon: PropTypes.node,
  leftIcon: PropTypes.node
};

export default Button;
